import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/css/reset.css";
import "./assets/css/common.scss";

import 'quill/dist/quill.snow.css';


import VueAMap from "vue-amap";

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "1fdc9974d8ba603e795ac4264895f719",
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.MouseTool",
    "AMap.PolyEditor",
    "AMap.LabelMarker",
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Heatmap",
    "AMap.Geocoder",
  ],
  v: "1.4.4",
});
Vue.prototype.formatHtml = function (html) {
  if (html) {
    return html
      .replace(/<[^<>]+>/g, "")
      .replace(/&nbsp;/gi, "");
  }
else{
  return ''
}

};

Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element-variables.scss'
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
